<template>
  <!-- 物资管理 -->
  <div class="dictionary clearfix">
    <div class="dictionary-left">
      <el-row class="dictionary-row">
        <el-col :span=9>
          <span class="dictionary-row-span-ml"><img src="@/assets/beadhouse/juxing.png" alt="" style="vertical-align:middle;"></span>
          <span style="height:54px;line-height:54px;font-size:16px;">仓库名称
          </span>
        </el-col>
        <el-col :span=3 :offset=12>
          <i class="el-icon-circle-plus-outline catalog_add" @click="addCatalog()"></i>
        </el-col>
      </el-row>
      <el-row style="width:90%;margin:10px auto;">
        <el-tree
          :data="treeList"
          node-key="id"
          :default-expand-all="false"
          :expand-on-click-node="false"
          @node-click="handleNodeDictionary"
          :props="defaultProps">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span> 
            <span>
              <el-button
                type="text"
                size="mini"
                @click="() => addProject(data)">
                <img src="@/assets/beadhouse/bigjia.png" alt="" class="vertical-align-cursor">
              </el-button>
              <el-button
                type="text"
                size="mini"
                @click="() => editCatalog(data)">
                <img src="@/assets/beadhouse/bianji_icon.png" alt="" class="vertical-align-cursor">
              </el-button>
              <el-button
                type="text"
                size="mini"
                @click="() => removeCatalog(node, data)">
                <img src="@/assets/beadhouse/shanchu_icon.png" alt="" class="vertical-align-cursor">
              </el-button>
            </span>
          </span>
        </el-tree>          
      </el-row>
    </div>
    <div class="dictionary-right">
      <el-row>
        <el-row class="dictionary-row">
          <el-col :span=2>
            <span class="dictionary-row-span-ml"><img src="@/assets/beadhouse/juxing.png" alt="" style="vertical-align:middle;"></span>
          </el-col>
          <el-col :span=4 :offset=9 style='font-size:16px'>物资管理</el-col>
          <el-col :span=2 :offset=7 align=center>
        </el-col>
        </el-row>
      </el-row>
      <el-row style="margin-top:10px;">
        <!--表格内容栏-->
        <el-table :data="tableData" :header-cell-style="tableHeaderColor" style="width: 100%" >
          <el-table-column prop="name" label="名称"  align=center></el-table-column>
          <el-table-column prop="type" label="仓库" align=center></el-table-column>
          <el-table-column prop="no" label="编号" align=center></el-table-column>
          <el-table-column prop="unit" label="单位" align=center></el-table-column>
          <el-table-column prop="norms" label="规格" align=center></el-table-column>
          <el-table-column prop="status" label="是否启用" width="80" align=center>
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.statusOn">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100" align=center>
            <template slot-scope="scope">
              <img src="@/assets/beadhouse/bianji_icon.png" alt="" class="imgSize" @click="EditProject(scope.$index,scope.row)">
              <img src="@/assets/beadhouse/shanchu_icon.png" alt="" class="imgSize" @click="deleteProject(scope.$index,scope.row)">
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </div>

     <!-- 新增 和  修改  服务类别的dialog模态框-->
    <el-dialog  :title="isaddOperation ? '新增物资仓库' : '修改物资仓库'" width="35%" 
      :visible.sync="dialogVisibleDictionaryForm" 
      :close-on-click-modal="false" 
      @close="closeDictionaryDialog">
      <el-form :model="dictionaryForm" label-width="120px" :rules="dictionaryFormRules" ref="dictionaryForm" label-position="right">
        <el-form-item label="类别名称" prop="name">
			    <el-input v-model.trim="dictionaryForm.name" auto-complete="off" placeholder="" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select
              v-model="dictionaryForm.type"
              style="width:80%;">
              <el-option value="1" label="日用杂品"></el-option>
              <el-option value="2" label="电子设备"></el-option>
              <el-option value="3" label="食材食品"></el-option>
              <el-option value="4" label="医用耗材"></el-option>
              <el-option value="5" label="捐赠物资"></el-option>
              <el-option value="6" label="固定资产"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleDictionaryForm = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitDictionaryForm" :loading="dictionaryFormLoading">确定</el-button>
      </div>
    </el-dialog>

    
     <!-- 新增 和  修改  服务项目的dialog模态框-->
     <el-dialog  :title="isaddOperation ? '新增物资项目' : '修改物资项目'" width="55%" 
     :visible.sync="dialogProjectVisible" 
     :close-on-click-modal="false" >
     <el-form :model="dialogProjectForm" label-width="120px" label-position="right">
      <el-row>
        <el-col :span="12">
          <el-form-item label="物资名称" prop="name">
            <el-input v-model.trim="dialogProjectForm.name" auto-complete="off" placeholder="" style="width:80%;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物资仓库" prop="type">
            <el-select
                v-model="dialogProjectForm.type"
                style="width:80%;">
                <el-option
                 v-for="item in treeList"
                 :key="item.id"
                 :label="item.name"
                 :value="item.name">
               </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编号" prop="no">
            <el-input v-model.trim="dialogProjectForm.no" auto-complete="off" placeholder="" style="width:80%;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12"> 
          <el-form-item label="是否启用" prop="status">
            <el-switch v-model="dialogProjectForm.statusOn" style="margin-top:10px"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位" prop="unit">
            <el-input v-model.trim="dialogProjectForm.unit" maxlength="8" auto-complete="off" placeholder="" style="width:80%;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规格" prop="norms">
            <el-input v-model.trim="dialogProjectForm.norms" maxlength="8" auto-complete="off" placeholder="" style="width:80%;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期" prop="period">
            <el-input v-model.trim="dialogProjectForm.period"  type="number" maxlength="5" auto-complete="off" placeholder="" style="width:80%;">
              <template slot="append">天</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input v-model.trim="dialogProjectForm.remark" auto-complete="off" placeholder="" style="width:80%;"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
     </el-form>
     <div slot="footer" class="dialog-footer" align="center">
       <el-button :size="size" @click.native="dialogProjectVisible = false">取消</el-button>
       <el-button :size="size" type="primary" @click.native="submitProjectForm">确定</el-button>
     </div>
   </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable"
import KtButton from "@/components/KtButton"
export default {
  name:'Dictionary',
  components:{KtTable,KtButton,},
  data(){
    return {
      isaddOperation:true,//默认是true  点击dialog显示的是新字典的dialog模态框
      size:'medium',//按钮的尺寸
      id:"",//当前菜单的id  默认显示第一个tree的菜单  
      pid:"",//父级的id
      treeList:[
      ],//服务项目树
      treeOneList:[],
      treeTwoList:[],
      treeThreeList:[],
      treeFourList:[],
      defaultProps: {
        children :'children',
        label :'name'
      },
      //新增和修改字典的dialog模态框的配置
      dialogVisibleDictionaryForm:false,//dialog模态框默认为隐藏
      dictionaryFormLoading:false,//新增和修改的确定按钮加载的loading  默认为false 不加载 
      dictionaryForm:{},//新增字典数据源
      dictionaryFormRules:{//验证的匹配规则
      },
      loading:false,//表格加载的loading
      dialogProjectVisible:false,
      dialogProjectForm:{},

      tableData: [
      ],
      //分页
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 4, //数据的总数,
    }
  },
  methods:{
    /* 
        关闭新增和修改服务的dialog
    */
    closeDictionaryDialog(){
      this.$nextTick(()=>{
        if(this.$refs.dictionaryForm){
          this.$refs.dictionaryForm.resetFields();//移除校验结果并重置字段值
        }
      })
    },
    /* 
      点击tree树
    */
    handleNodeDictionary(data, node, vuecomponent){
      this.type = data.name;
      this.getProjectList();
    },
    /* 
      新增服务 弹出dialog模态框
    */
    addCatalog() {
      this.isaddOperation=true;//true 新增的
      this.dialogVisibleDictionaryForm=true;//dialog模态框打开
      this.dictionaryForm = {
        name:"",
        type: "",
        groupId:this.groupId
      }
    },
    editCatalog(data){
      this.isaddOperation=false;//true 新增的
      this.dialogVisibleDictionaryForm=true;//dialog模态框打开
      this.dictionaryForm = {
        name:data.name,
        id:data.id,
        type: ""+(data.type||1),
        groupId:this.groupId
      }
    },
    /* 
        新增 和  修改 大类
    */
    submitDictionaryForm(){
      this.$refs.dictionaryForm.validate((valid) => {
        if (valid) {
          let params={};
          params = Object.assign({}, this.dictionaryForm);//拷贝需要提交的数据源
          this.dictionaryFormLoading=true;//确定按钮loadin为true;
          let url = "mdc/food/addCategory";
          if(params.id!=null){
            url = "mdc/food/editCategory";
          }
          this.$postJson(url,params).then(res=>{
            console.log(res);
            if(res.code==200){
              this.$message({message:res.message,type:"success"});
            }else{
              this.$message({message:res.message,type:"error"});
            }
            this.isaddOperation=true;//重置状态为true
            this.dictionaryFormLoading=false;//loading隐藏
            this.dialogVisibleDictionaryForm=false;//dialog模态框关闭
            this.getTree();//刷新字典树
            this.$refs.dictionaryForm.resetFields();//移除校验结果并重置字段值
          })
        }
      })
    },
    /* 
      删除类别 弹出dialog模态框
    */
    removeCatalog(node, data) {
      this.$confirm('确认删除服务类别吗？', '删除类别', {
				confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
			}).then(() => {
        this.$postForm("mdc/food/deleteCategoryById/"+data.id).then((res)=>{
          console.log(res);
          this.getTree();//刷新字典树
        })
      })
    },
    addProject(data){
      this.dialogProjectForm={
        name:"",
        type:data.name,
        no:"",
        statusOn:true,
        unit:"",
        norms:"",
        shopPrice:"",
        salePrice:"",
        lowerNum:"",
        period:"",
        remark:"",
        groupId:sessionStorage.getItem("groupId")
      }
      this.isaddOperation=true;//修改的
      this.dialogProjectVisible=true;//dialog模态框打开
    },
    /* 
      表格中的编辑
    */
    EditProject(index,row){
      this.dialogProjectForm={
        id:row.id,
        name:row.name,
        type:row.type,
        no:row.no,
        statusOn:row.statusOn,
        unit:row.unit,
        norms:row.norms,
        shopPrice:row.shopPrice,
        salePrice:row.salePrice,
        lowerNum:row.lowerNum,
        period:row.period,
        remark:row.remark,
        groupId:sessionStorage.getItem("groupId")
      }
      this.isaddOperation=false;//修改的
      this.dialogProjectVisible=true;//dialog模态框打开
    },
    /* 
      表格中的删除
    */
    deleteProject(index,row){
        this.$confirm('确认删除吗？', '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.$postForm("mdc/food/deleteProjectById/"+row.id).then((res)=>{
            console.log(res);
            this.getProjectList();//刷新
          })
        })
    },
    submitProjectForm(data){
      console.log(this.dialogProjectForm);
      this.dialogProjectForm.status = this.dialogProjectForm.statusOn?0:1;
      let params = Object.assign({}, this.dialogProjectForm);//拷贝需要提交的数据源
      let url = "mdc/food/addProject";
      if(params.id!=null){
        url = "mdc/food/editProject";
      }
      this.$postJson(url,params).then(res=>{
        console.log(res);
        if(res.code==200){
          this.$message({message:res.message,type:"success"});
        }else{
          this.$message({message:res.message,type:"error"});
        }
        this.isaddOperation=true;//重置状态为true
        this.dialogProjectVisible=false;//dialog模态框关闭
        this.getProjectList();//刷新字典树
      })
    },
    /* 
      查询服务类别树
    */
    getTree(){
      this.$postJson('mdc/food/queryCategory',{
        groupId:this.groupId
      }).then(res=>{
        if(res.code==200){
          this.treeList = res.result;
        }
      })
      this.type = null;
      this.getProjectList();
    },
    getProjectList(){
      //
      let params = {
        groupId:this.groupId,
        pageSize:99,
        pageNum:1,
        type:this.type
      }
      this.$postJson('mdc/food/queryProjectWithPage',params).then(res=>{
        if(res.code==200){
          res.result.list.forEach(item=>{
            item.statusOn = (item.status == 0);
          })
          this.tableData = res.result.list;
          
          console.log(this.tableData);
        }
      })
    },
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    },
  },
  created(){
    this.groupId = sessionStorage.getItem("groupId");

  },
  mounted(){
    this.getTree();
  },
}
</script>
<style lang="scss" scoped>
  .dictionary{
    width:100%;
    height:99.2%;
    margin-top:0.8%;
    background: #FEFEFE;
    .dictionary-left{
      float:left;
      width:22%;
      height:100%;
      border: 1px #bee1f4 solid;
      margin-right:2%;
      box-sizing:border-box;
      min-height:500px;
    }
    .dictionary-right{
      float:right;
      width:74%;
      height:100%;
      margin-right:2%;
      box-sizing: border-box;
    }
    .dictionary-row{
      height:54px;
      line-height:54px;
      background-color:#bee1f4;
      color:#6f7075;
      font-weight: 500;
      border:1px #bee1f4 solid;
    }
    .dictionary-row-span-ml{
      height:54px;
      line-height:54px;
      margin-left:10px;
    }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
    .vertical-align-cursor{
      vertical-align:middle;
      cursor:pointer;
      width:15px;
      height:15px;
    }
    .imgSize{
      vertical-align:middle;
      cursor:pointer;
      width:20px;
      height:20px;
    }
    .catalog_add{
      vertical-align:middle;
      cursor:pointer;
      font-size: 24px;
      color: #409eff;
    }
  }
</style>
